
import ByTankUpload from "../../backyard/view/tank/Upload.vue";

let lbTankRouter = [

];

let byTankRouter = [
	{
		path: 'tank/upload',
		name: "byTankUpload",
		component: ByTankUpload,
		meta: {
			requiresAuth: true,
			breadcrumbs: [
				{
					name: "byTankUpload",
					title: "文件上传"
				}
			]
		}
	}
];


export {lbTankRouter, byTankRouter}





// WEBPACK FOOTER //
// ./src/common/router/TankRouter.js